<template>
  <div>
    <div class="alert alert-info alert-dismissible fade in col-md-12" role="alert">
        <span class="typeprice">
          <span v-if="(jobRequestNotification||{}).appointment_level">
            Scheduled:
            <span v-for="jobRequestVisits in jobRequestNotification.jobRequestServicesNotification">
              <span v-for="jobRequestVisit in jobRequestVisits">
                {{ jobRequestVisit.service_name }} - {{ jobRequestVisit.display_start_end_date }}<br/>
              </span>
            </span>
            <strong><a data-toggle="modal" data-target="#job_request_popup" @click="fillJobAppointment('Accept')"
            >Accept</a> OR
                        <a data-toggle="modal" data-target="#job_request_popup" @click="fillJobAppointment('Decline')">Decline</a></strong>

            <confirmation-popup :title=title id="job_request_popup" :confirm-btn-text=(jobRequestNotification||{}).confirmBtnTxt
                                cancel-btn-text="Cancel" @on-confirm="submitAppointmentForm" :close-after-confirm="false">
              <form class="form-horizontal" id="job_request_appointment_form" method="post"
                    :action="actionUrl" >
                  <input type="hidden" name="contractor_id" v-model="(jobRequestNotification||{}).loggedContractorId"/>
                  <input type="hidden" name="booking_id" v-model="(jobRequestNotification||{}).bookingId"/>
                  <input type="hidden" name="is_accepted" v-model="(jobRequestNotification||{}).isAccepted" />
                  <input type="hidden" name="os" value="web"/>
                  <ul class="job-dropdown-menu">
                    <li v-for="jobRequestVisits in jobRequestNotification.jobRequestServicesNotification">
                      <input type="checkbox" class="job_request_check job_service"  @change="multipleDaysChanged" checked/><strong>{{ jobRequestVisits[0].service_name }}</strong>
                      <ul>
                        <li class="child-node" v-for="jobRequestVisit in jobRequestVisits">
                          <input type="checkbox" name="multiple_day_ids[]" @change="multipleDaysChanged" :value="jobRequestVisit.multiple_day_id" class="job_request_check job_appontment" checked/>{{ jobRequestVisit.display_start_end_date }}
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <span class="has-error" style="display: none;">You should choose at least one notification to send</span>
              </form>

            </confirmation-popup>
          </span>
          <span v-else>
              Do you want to <strong><a data-toggle="modal" data-target="#acceptBookingRequest">Accept</a> OR
                        <a data-toggle="modal" data-target="#declineBookingRequest">Decline</a></strong> this booking.

            <confirmation-popup title="Accept booking" id="acceptBookingRequest" confirm-btn-text="Yes"
                                cancel-btn-text="Cancel" @on-confirm="acceptBookingRequest">
              Are you sure you want to accept this booking?
            </confirmation-popup>
            <confirmation-popup title="Decline booking" id="declineBookingRequest" confirm-btn-text="Yes"
                    cancel-btn-text="Cancel" @on-confirm="declineBookingRequest">
              Are you sure you want to decline this booking?
            </confirmation-popup>
          </span>
        </span>
    </div>
  </div>
</template>

<script>
// const actionUrl = 'webservice/accept-or-reject-assigned-booking'
export default {
  name: "JobRequestNotification",
  props: {
    value: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data(){
    return {
      jobRequestNotification: this.value,
      actionUrl: '/webservice/accept-or-reject-assigned-booking',
      title: "Accept"
    }
  },
  methods: {
    acceptBookingRequest(){
      window.location = this.actionUrl+`?booking_id=${this.jobRequestNotification.bookingId}&os=web&is_accepted=1`
    },
    declineBookingRequest(){
      window.location = this.actionUrl+`?booking_id=${this.jobRequestNotification.bookingId}&os=web&is_accepted=0`
    },
    fillJobAppointment(action){
      if(action=="Accept"){
        this.jobRequestNotification.isAccepted = 1
        $("input[name='is_accepted']").val(1)
        this.title = "Accept appointments"
      }else{
        this.jobRequestNotification.isAccepted = 0
        $("input[name='is_accepted']").val(0)
        this.title = "Decline appointments"
      }
      this.jobRequestNotification.confirmBtnTxt = action
    },
    multipleDaysChanged(event){
      if($(event.target).hasClass("job_service")){
        if($(event.target).is(":checked")){
          $(event.target).parent().find(".job_appontment").prop('checked',true);
        }else
          $(event.target).parent().find(".job_appontment").prop("checked",false);
      }else if($(event.target).hasClass("job_appontment")){
        if($(event.target).is(":checked")){
          if($(event.target).closest("ul").find(".job_appontment:checked").length==
              $(event.target).closest("ul").find(".job_appontment").length)
            $(event.target).closest("ul").closest("li").find(".job_service").prop('checked',true);
        }else{
          $(event.target).closest("ul").closest("li").find(".job_service").prop("checked",false);
        }
      }
    },
    submitAppointmentForm(event){
      let multiple_days_ids = $("#job_request_appointment_form").find("input[name='multiple_day_ids[]']:checked").map(function(){
        return $(this).val()
      }).get();
      if(multiple_days_ids.length==0){
        $("#job_request_appointment_form").find(".has-error").show();
        event.preventDefault();
      }else{
        $("#job_request_appointment_form").find(".has-error").hide();
        // console.log($("input[name='is_accepted']").val())
        // console.log($("#job_request_appointment_form").serializeArray())
        $("#job_request_appointment_form").submit();
      }
    }
  },
  mounted(){

  },
}
</script>
<style scoped>
p.has-error{
  text-align: left;
}
</style>